import { render, staticRenderFns } from "./UserRootPage.vue?vue&type=template&id=09b98916&scoped=true&"
import script from "./UserRootPage.vue?vue&type=script&lang=js&"
export * from "./UserRootPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b98916",
  null
  
)

export default component.exports